import CityPage from "../CityPage";

export default function DownersGrove() {
  return <CityPage slug="downers-grove" />;
}
